export default __webpack_public_path__ + "static/media/172.3903d381.jpg";